/* We can disable import/no-cycle here because we know that
  api only depends on the User module. */
// eslint-disable-next-line import/no-cycle
import api from '@/api';

const localState = {
  loaded: false,
  user: null,
};

const actions = {
  async getUser({ commit }, id) {
    commit('SET_LOADING', true);
    await api.get(`/account/getUser/${id}`).then((response) => {
      commit('SET_USER', response.data);
      commit('SET_LOADING', false);
      commit('LOADED');
    }).catch(() => {
      commit('SET_LOADING', false);
    });
  },
  unload({ commit }) {
    commit('SET_USER', null);
  },
  async updateMFSUser(_things, { data, submittedCallback }) {
    await api.patch(`/account/updateMFSUser/${data.id}`, data)
      .then(() => {
        submittedCallback();
      });
  },
  async updateTCEOUser(_things, { data, submittedCallback }) {
    await api.patch(`/account/updateTCEOUser/${data.id}`, data)
      .then(() => {
        submittedCallback();
      });
  },
  async updateINFWBUser(_things, { data, submittedCallback }) {
    await api.patch(`/account/updateINFWBUser/${data.id}`, data)
      .then(() => {
        submittedCallback();
      });
  },
  async createMFSUser(_things, { data, submittedCallback }) {
    await api.post('/account/createMFSUser', data)
      .then(() => {
        submittedCallback();
      });
  },
  async createTCEOUser(_things, { data, submittedCallback }) {
    await api.post('/account/createTCEOUser', data)
      .then(() => {
        submittedCallback();
      });
  },
  async createINFWBUser(_things, { data, submittedCallback }) {
    await api.post('/account/createINFWBUser', data)
      .then(() => {
        submittedCallback();
      });
  },
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  LOADED(state) {
    state.loaded = true;
  },
};

const getters = {
  users: state => state.users,
};

export default {
  actions,
  getters,
  mutations,
  state: localState,
  namespaced: true,
};
